import { getActiveUserId } from '../../../helpers';
import { Cart } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { Context } from '@vue-storefront/core';
import { LoadUserCartsProps } from 'composables/src/types';

export async function loadUserCarts(
  context: Context,
  params: LoadUserCartsProps
): Promise<Cart[]> {
  const {
    $sapcc: {
      config: { $cookies }
    }
  } = context;

  const userId = getActiveUserId($cookies);

  const { carts } = await context.$sapcc.api.getCarts({ ...params, userId });

  return carts;
}
